<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const LiveCasinoTabIcon = getIcon("LiveCasinoTabIcon");
export let size = 17;
export let active = false;
export let hover = false;
export let color = undefined;
</script>

{#if typeof LiveCasinoTabIcon === 'string'}
	<img src={LiveCasinoTabIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof LiveCasinoTabIcon === 'function'}
	<svelte:component this={LiveCasinoTabIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
